import { render, staticRenderFns } from "./OnboardingCopyright.vue?vue&type=template&id=0528e750&scoped=true"
import script from "./OnboardingCopyright.vue?vue&type=script&lang=js"
export * from "./OnboardingCopyright.vue?vue&type=script&lang=js"
import style0 from "./OnboardingCopyright.vue?vue&type=style&index=0&id=0528e750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0528e750",
  null
  
)

export default component.exports